import { render, staticRenderFns } from "./BankListItem.vue?vue&type=template&id=8ff0c994&"
import script from "./BankListItem.vue?vue&type=script&lang=js&"
export * from "./BankListItem.vue?vue&type=script&lang=js&"
import style0 from "./BankListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports